import React from 'react'

const LandingPage: React.FC = () => {
  return (
    <React.Fragment>
      <span>Please wait...</span>
    </React.Fragment>
  )
}

export default LandingPage
